import React, { useState } from "react";
import DirectorsForm from "./DirectorsForm";
import { useCallbackPrompt } from "../../hooks/useCallbackPrommpt";
import { useDispatch } from "react-redux";
import ConfirmationDialog from "../confirmation-dialog/ConfirmationDialog";
import { resetRegData } from "./directorsRegFormSlice";

const AddDirectors = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(showDialog);
  const dispatch = useDispatch();

  const handleConfirmNavigation = () => {
    dispatch(resetRegData());
    confirmNavigation();
  };

  return (
    <>
      <ConfirmationDialog
        show={showPrompt}
        onConfirm={handleConfirmNavigation}
        onCancel={cancelNavigation}
      />
      <DirectorsForm setShowDialog={setShowDialog} />
    </>
  );
};

export default AddDirectors;
